import React from "react";

const PreviewPicture = props => {
  const { pictureUrl } = props;
  return <img src={pictureUrl} alt={pictureUrl}  className="preview-img" />;
};

export default PreviewPicture;
